// Production Environment Configuration
export const environment = {
  production: true,
  environment: 'prod',
  apiBaseUrl: 'https://amba-usweb.com/amba-engineering-service',
  endpoints: {
    common: '/common',
    ieee: '/ieee',
    asme: '/asme'
  },
  analytics: {
    enabled: true,
    gtmContainerId: 'GTM-TQLCGRK'
  },
  timeout: 30000 // 30 seconds
};
